import { useModalContext } from "../../contexts/ModalContext";
import { useFirebaseWishesDataFetch } from "../../contexts/FirebaseConnectionContext";
import { doc, deleteDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase-confg";

const WishesDataModal = () => {

    const { modalState, closeModal } = useModalContext()
    const { wishesRef } = useFirebaseWishesDataFetch();

    const wishUrl = modalState?.wishData?.url?.length > 20 ? `${modalState?.wishData?.url.substr(0, 20)}...` : modalState?.wishData?.url;

    async function editWish(e) {
        const wishRef = doc(wishesRef, modalState?.wishData?.id);

        if (e.target.id === "title" && e.target.value !== modalState?.wishData?.title) {
            await updateDoc(wishRef, {
                title: e.target.value,
            });
        }
        if (e.target.id === "price" && e.target.value !== modalState?.wishData?.price) {
            await updateDoc(wishRef, {
                price: e.target.value,
            });
        }
        if (e.target.id === "url" && e.target.value !== modalState?.wishData?.url) {
            await updateDoc(wishRef, {
                url: e.target.value,
            });
        }
        if (e.target.id === "description" && e.target.value !== modalState?.wishData?.description) {
            await updateDoc(wishRef, {
                description: e.target.value,
            });
        }
        if (e.target.id === "statusChange" && e.target.value !== modalState?.wishData?.granted) {
            await updateDoc(wishRef, {
                granted: e.target.value,
            });
        }
    }

    async function deleteWishById() {
        await deleteDoc(doc(db, "wishes", modalState?.wishData?.id));
    }

    return (
        <div id="contenant" className="flex flex-col font-semibolditems mt-4" >
            <div id="wishTitle" className="text-ivory bg-darkRed rounded-md global-px py-2 shadow-inner shadow-darkOrange" >
                <label className="flex justify-between font-bold text-darkOrange">
                    Souhait :{ }
                </label>
                {modalState?.editModalData ? (
                    <input
                        type="text"
                        id="title"
                        defaultValue={modalState?.wishData?.title}
                        className="placeholder:text-darkYellow border-b-darkYellow border-b-2 bg-darkRed outline-none"
                        onChange={(e) => editWish(e)}
                    />
                ) : (
                    <p>{modalState?.wishData?.title}</p>
                )}
            </div>
            <div className="global-px">
                <label className="flex mt-4 font-bold">
                    Statut :
                    {modalState?.editModalData ? (
                        <select
                            id="statusChange"
                            className="placeholder:text-darkYellow border-b-darkYellow bg-inherit border-b-2 "
                            onChange={(e) => editWish(e)}
                            defaultValue={modalState?.wishData?.granted}
                        >
                            <option>Réservé</option>
                            <option>Non reservé</option>
                        </select>
                    ) : (
                        <p className="font-normal ml-2">
                            {modalState?.wishData?.granted ? "Réservé" : "Non reservé"}
                        </p>
                    )}
                </label>
            </div>
            <div
                id="priceDiv"
                className="flex justify-between mt-4 global-px"
            >
                <label className="font-bold flex">
                    Prix :
                    {modalState?.editModalData ? (
                        <input
                            id="price"
                            onChange={(e) => editWish(e)}
                            defaultValue={modalState?.wishData?.price}
                            className="placeholder:text-darkYellow border-b-darkYellow bg-inherit border-b-2"
                        ></input>
                    ) : (
                        <p className="ml-2">{modalState?.wishData?.price}</p>
                    )}
                </label>
            </div>

            <div id="linkDiv" className="mt-4 global-px">
                <label className="flex justify-between font-bold">
                    Lien :{" "}
                </label>
                {modalState?.editModalData ? (
                    <input
                        className=" placeholder:text-darkYellow bg-inherit border-b-2 border-b-darkOrange w-full"
                        onChange={(e) => editWish(e)}
                        id="url"
                        defaultValue={modalState?.wishData?.url}
                    ></input>
                ) : (
                    <a
                        className="hover:underline"
                        href={modalState?.wishData?.url}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        {wishUrl}
                    </a>
                )}
            </div>
            <div id="descriptionDiv" className="mt-4 global-px">
                <label className="flex justify-between font-bold">
                    Description :
                </label>
                {modalState?.editModalData ? (
                    <textarea
                        id="description"
                        onChange={(e) => editWish(e)}
                        defaultValue={modalState?.wishData?.description}
                        className="placeholder:text-darkYellow border-b-darkYellow border-b-2 rounded-[0.25em] w-full"
                    ></textarea>
                ) : (
                    <p className="overflow-y-autoscroll">{modalState?.wishData?.description}</p>
                )}
            </div>
            <div className="flex w-full justify-around">
                <button
                    onClick={deleteWishById}
                    className="gradient text-ivory mt-[0.5em] text-[1em] p-[.5em] border-2 rounded-[0.25em]"
                >
                    Supprimer
                </button>
                <button
                    onClick={closeModal}
                    className="gradient text-ivory mt-[0.5em] text-[1em] p-[.5em] border-2 rounded-[0.25em]"
                >
                    Valider
                </button>
            </div>
        </div>
    );
};

export default WishesDataModal;